import { PROJECT_ADMIN_STATUS_TYPE, QUOTATION_KIND, USER_TYPE } from 'models/SupplementEnum';
import { urlCompiler } from './compiler';

/**
 *  route Link url 관련 constants
 */
export const LOGIN = '/';
export const LOGOUT = '/auth/logout';

export const USER_LIST = '/user';
export const USER_DETAIL = '/user/detail/[id]';

export const PROJECT_LIST = '/project';
export const PROJECT_DETAIL = `/project/detail`;
export const PROJECT_SEMI_AUTO_SEARCH = '/project/detail/semiAutoSearch';
export const PROJECT_DETAIL_QUOTATION_CONTENT = `${PROJECT_DETAIL}/quotationContent`;
export const PROJECT_DETAIL_FINISH = `${PROJECT_DETAIL}/finish`;

export const SELL_REQUEST_LIST = '/project/sell';
export const SELL_REQUEST_DETAIL = '/project/sell/detail/[id]';

export const SYNONYM_MANAGE = '/synonym';

export const userListPath = urlCompiler<{
  page?: string;
  email?: string;
  name?: string;
  phone?: string;
  company_name?: string;
  type?: USER_TYPE;
}>(USER_LIST);

export const projectListPath = urlCompiler<{
  page?: number;
  project_name?: string;
  rfq_number?: string;
  company_name?: string;
  manager?: string;
  finish?: boolean;
  progress?: string;
}>(PROJECT_LIST);

export const sellReqeustListPath = urlCompiler<{
  page?: string;
  company_name?: string;
  name?: string;
}>(SELL_REQUEST_LIST);

export const projectDetailPath = urlCompiler<{
  kind?: QUOTATION_KIND;
  rfqNumberId?: number;
  quotationId?: number;
}>(PROJECT_DETAIL);
export const projectDetailQuotaionContentPath = urlCompiler<{
  kind?: QUOTATION_KIND;
  rfqNumberId?: number;
  quotationId?: number;
  orderId?: number;
}>(PROJECT_DETAIL_QUOTATION_CONTENT);
export const projectDetailQuotaionFinishPath = urlCompiler<{
  kind?: QUOTATION_KIND;
  rfqNumberId?: number;
  quotationId?: number;
  orderId?: number;
}>(PROJECT_DETAIL_FINISH);

export const synonymManagePath = urlCompiler<{ page?: number; target?: string; is_confirm?: string; value?: string }>(
  SYNONYM_MANAGE,
);

export const projectSemiAutoSearchPath = urlCompiler<{
  rfqNumberId?: number;
  quotationId?: number;
  kind?: QUOTATION_KIND;
}>(PROJECT_SEMI_AUTO_SEARCH);
